import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

const defaultTitle = '韩国漫画大全-免费韩漫在线观看下拉式-好看的韩国漫画-韩漫屋';
const defaultDescription = '韩漫屋拥有完整的韩国漫画大全，免费在线观看并采用下拉式界面，呈现好看的韩漫供您探索。涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情等多种类型的韩国漫画。';
const defaultKeywords = '韩国漫画大全, 免费韩漫在线观看, 下拉式, 好看的韩国漫画, 韩漫屋';
const defaultUrl = 'https://hanmanwu.com';

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType,
  ogTitle,
  ogDescription,
  ogImage,
}: SEOHeadProps) {
  useEffect(() => {
    const pageTitle = title ? `${title} - 韩漫屋` : defaultTitle;
    document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description || defaultDescription);
    setMeta('keywords', keywords || defaultKeywords);

    const currentCanonical = document.querySelector('link[rel="canonical"]');
    if (currentCanonical) {
      currentCanonical.setAttribute('href', canonicalUrl || defaultUrl);
    }

    setMeta('og:title', ogTitle || title || defaultTitle, true);
    setMeta('og:description', ogDescription || description || defaultDescription, true);
    setMeta('og:type', ogType || 'website', true);
    setMeta('og:url', canonicalUrl || defaultUrl, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:title', ogTitle || title || defaultTitle);
    setMeta('twitter:description', ogDescription || description || defaultDescription);
  }, [title, description, keywords, canonicalUrl, ogType, ogTitle, ogDescription, ogImage]);

  return null;
}